import React, { Fragment } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { FormTextField, PasswordField } from "../../../generic/GenericTextFields";
import { useFormik } from "formik";
import { object } from "yup";
import { login } from "../../../../config/apisauce";
import { loginValidations } from "../../../../helpers/genericFormValidations";
import { DontHaveAccount } from "../generic/GenericDialogFooter";
import { LOGIN_FORMS } from "../../../../enums/loginFormEnums";
import { router } from '@inertiajs/react';
import { ADMIN_ROLE, CREATOR_ROLE, DEVELOPER_ROLE, PENDING_CREATOR_ROLE } from "../../../../enums/generalEnums";
import { SIGN_IN_FORMS } from "../../../../enums/signInFormEnums";

export const LoginForm = (props) => {
  const {
    setUserDetails,
    handleOpenSignUpDialog,
    handleNextForm,
    handleCloseDialog,
    setOpenProfileSetupDialog
  } = props;

  const handleSubmit = async (values) => {
    const response = await login(values);

    if (response?.data?.error === "banned") {
      handleNextForm({...SIGN_IN_FORMS[5]});
      return;
    }

    if (response.ok) {
      if (response?.data?.role === ADMIN_ROLE || response?.data?.role === DEVELOPER_ROLE) {
        router.visit('/admin');
      } else if (response?.data?.role === CREATOR_ROLE || response?.data?.role === PENDING_CREATOR_ROLE) {
        setUserDetails(response?.data);
        if (response?.data?.status === 'email_verified') {
          setOpenProfileSetupDialog(true);
        } else {
          if (response?.data?.role === PENDING_CREATOR_ROLE) {
            router.visit('/edit-profile');
          } else {
            router.visit('/overview');
          }
        }
      }
      handleCloseDialog();
    }else{
      if (response?.data?.errors?.email?.includes("unverified")) {
        handleNextForm({
          ...SIGN_IN_FORMS[4],
          data: {
            email: formik?.values?.email,
          }
        });
      }
    }
  };

  const formik = useFormik({
    initialValues: {},
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: object().shape(loginValidations),
    enableReinitialize: true,
    onSubmit: (values) => handleSubmit(values),
  });

  return (
    <Fragment>
      <form onSubmit={formik.handleSubmit}>
        <Stack gap={4} mb={0.5}>
          <FormTextField
            value={formik.values.email}
            placeholder={'example@email.com'}
            label={'Email'}
            error={Boolean(formik?.errors?.email)}
            helperText={formik?.errors?.email}
            handleChange={(value) => formik.setFieldValue('email', value)}
          />
          <PasswordField
            value={formik?.values.password}
            placeholder={'************'}
            label={'Password'}
            error={Boolean(formik?.errors?.password)}
            helperText={formik?.errors?.password}
            handleChange={(value) => formik.setFieldValue('password', value)}
          />
        </Stack>
        <Typography variant="body2" color="primary" textAlign={'right'}><span style={{ cursor: 'pointer' }} onClick={() => handleNextForm(LOGIN_FORMS[1])}>Forgot Password?</span></Typography>
        <Stack gap={4} mt={4}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button variant="contained" sx={{ color: '#FFF', width: { xs: '100%', sm: '250px' } }} type="submit">Log In</Button>
          </Box>
          <DontHaveAccount handleOpenSignUpDialog={handleOpenSignUpDialog} />
        </Stack>
      </form>
    </Fragment>
  );
};